import { render, staticRenderFns } from "./MediaStats.vue?vue&type=template&id=beea98f2&scoped=true"
import script from "./MediaStats.vue?vue&type=script&lang=ts"
export * from "./MediaStats.vue?vue&type=script&lang=ts"
import style0 from "./MediaStats.vue?vue&type=style&index=0&id=beea98f2&prod&scoped=true&lang=css"
import style1 from "./MediaStats.vue?vue&type=style&index=1&id=beea98f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beea98f2",
  null
  
)

export default component.exports